import EventLog from './event-log.controller';

export default EventLog;
